function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
import "@nord/ui/es/Text/style/css";
import _Text from "@nord/ui/es/Text";
var _excluded = ["isSubmitting", "onSubmit", "resetPasswordTitle"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null)
    return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0)
            continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key))
            continue;
        target[key] = source[key];
    }
} return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null)
    return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
        continue;
    target[key] = source[key];
} return target; }
import LazyImage from '@nordvpn/teams.core/lib/atoms/LazyImage';
import resetPasswordLowResImg from '@nordvpn/teams.core/lib/auth/assets/img/Reset-pass.png';
import resetPasswordImg from '@nordvpn/teams.core/lib/auth/assets/img/Reset-pass.svg';
import TwoColView from '@nordvpn/teams.core/lib/templates/TwoColView';
import Form from 'components/organisms/ResetPasswordForm';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ResetPassword = function ResetPassword(_ref) {
    var isSubmitting = _ref.isSubmitting, onSubmit = _ref.onSubmit, _ref$resetPasswordTit = _ref.resetPasswordTitle, resetPasswordTitle = _ref$resetPasswordTit === void 0 ? 'Reset your password' : _ref$resetPasswordTit, restProps = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/ _jsx(TwoColView, {
        leftPanel: /*#__PURE__*/ _jsx(LazyImage, {
            src: resetPasswordImg,
            alt: "Forgot password",
            preview: resetPasswordLowResImg
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "md:mr-5",
            children: [/*#__PURE__*/ _jsx(_Text, {
                    className: "mb-8px reset-password-header text-grey-tuna font-bold",
                    variant: "subtitle1",
                    children: resetPasswordTitle
                }), /*#__PURE__*/ _jsx(Form, _objectSpread(_objectSpread({}, restProps), {}, {
                    onSubmit: onSubmit,
                    isSubmitting: isSubmitting
                }))]
        })
    });
};
export default ResetPassword;
